import { handleDownload } from '@/utils/http'
import request from '@/utils/request'

/**
 * 代码生成功能API
 */

const BASE_URL = 'dev/codegen'

/**
 * 表信息分页查询
 */
export const TABLE_PAGE_URL = BASE_URL + '/table-page'

/**
 * 获取表信息
 *
 * @param tableName 表名
 * @return {Promise}
 */
export function getBusiness(tableName: string) {
  return request({
    url: BASE_URL + '/business/' + tableName,
    method: 'get'
  })
}

/**
 * 预览代码
 *
 * @param biz 功能信息
 * @return {Promise}
 */
export function previewCode(biz: any) {
  return request({
    url: BASE_URL + '/preview',
    method: 'post',
    data: biz
  })
}

/**
 * 生成代码到路径
 *
 * @param biz 功能信息
 * @return {Promise}
 */
export function genToPath(biz: any) {
  return request({
    url: BASE_URL + '/gen-to-path',
    method: 'post',
    data: biz
  })
}

/**
 * 生成菜单/权限
 *
 * @param biz 功能信息
 * @return {Promise}
 */
export function genMenuAuth(biz: any) {
  return request({
    url: BASE_URL + '/gen-menu-auth',
    method: 'post',
    data: biz
  })
}

/**
 * 下载代码
 *
 * @param biz 功能信息
 * @return {Promise}
 */
export function download(biz: any) {
  return request({
    url: BASE_URL + '/download',
    method: 'post',
    data: biz,
    responseType: 'blob'
  }).then(result => {
    handleDownload(result)
  })
}

/**
 * 下载导出模板
 *
 * @param biz 功能信息
 * @return {Promise}
 */
export function downloadExportTemplate(biz: any) {
  return request({
    url: BASE_URL + '/download-export-template',
    method: 'post',
    data: biz,
    responseType: 'blob'
  }).then(result => {
    handleDownload(result)
  })
}

/**
 * 下载导入模板
 *
 * @param biz 功能信息
 * @return {Promise}
 */
export function downloadImportTemplate(biz: any) {
  return request({
    url: BASE_URL + '/download-import-template',
    method: 'post',
    data: biz,
    responseType: 'blob'
  }).then(result => {
    handleDownload(result)
  })
}
